import Splide from '@splidejs/splide';
import {gsap} from 'gsap';
import {ScrollTrigger} from "gsap/dist/ScrollTrigger";
export default class BlockProjectSlider {
  slider() {
    const slider = new Splide('.projects-carousel', {
      type: 'loop',
      perPage: 4,
      pagination: false,
      arrows: false,
      perMove: 1,
      gap: '34px',
      breakpoints: {
        768: {
          perPage: 1,
          gap: '0px',
        },
        1000: {
          perPage: 2
        },
        1500: {
          perPage: 3
        },
      }
    }).mount();

    const arrowPrev = document.querySelector('.arrow-left');
    const arrowNext = document.querySelector('.arrow-right');
    if (document.contains(arrowPrev)) {
      arrowPrev.addEventListener('click', () => {
        slider.go('<');
      })
    }
    if (document.contains(arrowNext)) {
      arrowNext.addEventListener('click', () => {
        slider.go('>');
      })
    }
  }
  desktopSlider() {
    gsap.registerPlugin(ScrollTrigger);
    let sections = gsap.utils.toArray(".projects-carousel-desktop__item");
    gsap.to(sections, {
      xPercent: -100 * (sections.length - 1),
      ease: "none",
      scrollTrigger: {
        trigger: ".projects-carousel-desktop",
        pin: true,
        scrub: 1,
        start: '10% 10%',
        snap: 1 / (sections.length - 1),
        end: () => "+=" + document.querySelector(".projects-carousel-desktop").offsetWidth
      }
    });
  }
  render() {
    this.slider();
    this.desktopSlider();
  }
}

function Load() {
  const load = new BlockProjectSlider();
  load.render();
}


document.addEventListener('DOMContentLoaded', Load, {passive: true});



// WEBPACK FOOTER //
// ./resources/assets/js/blocks/block-project-slider.js